import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getReportGenerationBugId, noWhitespaceValidator } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { commonEnum } from '../../../../shared/src/lib/constants';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'piqet-angular-report-bug',
  templateUrl: './report-bug.component.html',
  styleUrls: ['./report-bug.component.scss'],
})
export class ReportBugComponent {
  modalLabel = commonEnum.reportABug;
  reportBugForm!: FormGroup;
  categoryList: any[] = [];

  selectedFiles: any[] = [];
  fileToUpload: any;
  imagePreview = '';
  getImage: any;
  isImageValid = true;
  isShowChange = false;
  isShowChangeVideo = false;
  fileBase64: any[] = [];
  imageUrls: string[] = [];
  isShowImage: any;
  submitted = false;
  imageLimitExceeded = false;
  fileErrorMessage = false;
  fileSizeExceeded = false;
  currentCategoryId: any;
  currentCategoryName: any;
  optionParentId: any;

  @ViewChild('myFileInput', { static: false }) myFileInput!: ElementRef<HTMLInputElement>;
  fileLimitExceeded: boolean = false;
  isFileValid: boolean = true;
  fileUrls: any = [];
  existData: any;
  currentNote: any;
  reportPayload: any;
  reportResponse: any;
  categoryInfo: any;

  isSubmitting = false;
  constructor(
    private sharedService: SharedService,
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private toaster: ToastrService
  ) {
    this.existData = this.modal?.modalService?.config?.initialState?.['existModalData'];
    this.reportPayload = this.modal?.modalService?.config?.initialState?.['payload'];
    this.reportResponse = this.modal?.modalService?.config?.initialState?.['response'];
    this.categoryInfo = this.modal?.modalService?.config?.initialState?.['categoryInfo'];
  }

  ngOnInit() {
    this.loadCategories();
    this.currentCategoryId = this.existData?.categoryId ?? this.categoryInfo?.id ?? null;
    this.currentCategoryName = this.categoryInfo?.name ?? '';
    this.reportBugForm = this.formBuilder.group({
      category: [this.currentCategoryId ?? null, Validators.required],
      description: [
        this.existData?.description ?? '',
        [Validators.required, noWhitespaceValidator],
      ],
    });
    if (this.existData) {
      this.fileUrls = this.convertFiles(this.existData.bugReportAttachments);
    }
  }

  convertFiles(backendFiles: any) {
    return backendFiles.map((file: any) => {
      const extension = file.fileName.split('.').pop()?.toLowerCase();
      let type = 'unknown';

      switch (extension) {
        case 'jpeg':
        case 'jpg':
          type = 'image/jpeg';
          break;
        case 'png':
          type = 'image/png';
          break;
        case 'mp4':
          type = 'video/mp4';
          break;
        case 'avi':
          type = 'video/avi';
          break;
        case 'mkv':
          type = 'video/mkv';
          break;
        default:
          type = 'unknown';
          break;
      }

      return {
        type,
        url: file.fileName,
      };
    });
  }

  loadCategories(): void {
    this.http.get<any[]>('../../../assets/json/categories.json').subscribe(
      data => {
        this.categoryList = data;
      },
      error => {
        console.error('Error loading categories:', error);
      }
    );
  }

  onClose() {
    this.modal.close();
  }

  categorySearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  fileChangeEvent(event: any) {
    const files = event.target.files;
    let validFilesCount = this.selectedFiles.length;

    // Reset validation state
    this.imageLimitExceeded = false;
    this.fileSizeExceeded = false;
    this.isFileValid = true;

    if (files.length > 5) {
      this.imageLimitExceeded = true;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const mimeType = file?.type;

      if (validFilesCount >= 5) {
        break;
      }

      if (!this.isValidFileType(mimeType)) {
        this.isFileValid = false;
        continue;
      }

      if (!this.isValidFileSize(file.size)) {
        this.fileSizeExceeded = true;
        continue;
      }

      // Add the valid file
      this.selectedFiles.push(file);
      validFilesCount++;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fileUrls.push({
          url: e.target.result,
          type: mimeType,
        });
        this.fileBase64.push({ base64: e.target.result.split(',')[1], fileName: file.name });
        this.isShowChange = true;
      };

      reader.readAsDataURL(file);
    }

    this.isShowChange = this.selectedFiles.length > 0;
  }

  isValidFileType(mimeType: string): boolean {
    const allowedImageTypes = ['image/png', 'image/jpg', 'image/jpeg'];
    const allowedVideoTypes = ['video/mp4', 'video/avi', 'video/mkv'];
    return allowedImageTypes.includes(mimeType) || allowedVideoTypes.includes(mimeType);
  }

  isValidFileSize(size: number): boolean {
    const maxSizeInBytes = 100 * 1024 * 1024; // 100MB
    return size <= maxSizeInBytes;
  }

  removeFiles() {
    this.selectedFiles = [];
    this.fileUrls = [];
    this.fileBase64 = [];
    this.isShowChange = false;
  }

  removeParticularFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.fileUrls.splice(index, 1);
    this.fileBase64.splice(index, 1);
    this.isShowChange = this.selectedFiles.length > 0;
  }

  categoryObj(selectedItem: any) {
    this.optionParentId = null;
    this.optionParentId = selectedItem.parentId;
    this.currentNote = this.categoryList.filter(c => c.id == selectedItem.parentId)[0]?.message;
    this.currentCategoryId = selectedItem.id;
    this.currentCategoryName = selectedItem.name;
  }

  saveReportBug() {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.submitted = true;
    if (this.reportBugForm.invalid || !this.isImageValid) {
      this.isSubmitting = false;
      return;
    }
    const payload = {
      categoryId: this.currentCategoryId,
      categoryName: this.currentCategoryName,
      description: this.reportBugForm.get('description')?.value,
      bugReportAttachments: this.fileBase64,
      payload: JSON.stringify(this.reportPayload),
      response: JSON.stringify(this.reportResponse),
    };
    this.sharedService.addBugReport(payload).subscribe(
      (res: any) => {
        if (res.messageType == 0) {
          this.modal.close();
          this.toaster.success(res.message);
        } else {
          this.toaster.error(res.message);
        }
      },
      (error: any) => {
        this.isSubmitting = false;
        this.toaster.error(error.message);
      }
    );
  }

  onClick(fileUrl: string, type: string): void {
    const baseSwalConfig = {
      padding: '0px',
      showCancelButton: false,
      showConfirmButton: false,
      backdrop: `
      rgba(217, 217, 217, 0.8)
      url("/images/nyan-cat.gif")
      left top
      no-repeat
    `,
      customClass: {
        image: 'swal2-image-custom-class',
      },
    };

    if (type === 'image') {
      Swal.fire({
        ...baseSwalConfig,
        imageUrl: fileUrl,
        imageWidth: '100%',
        imageHeight: '100%',
        imageAlt: 'Custom image',
      });
    } else if (type === 'video') {
      Swal.fire({
        ...baseSwalConfig,
        html: `
        <video width="400" height="350" controls autoplay>
          <source src="${fileUrl}" type="video/mp4">
        </video>
      `,
        padding: '0px 0px 60px 0px',
        imageAlt: 'Custom video',
      });
    }
  }
}
